import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaHistoryList extends HTMLAhaHistoryListElement {}

/**
 * A "history list" element (hence the name `<aha-history-list>`).
 *
 * Takes any number of `<aha-history-list-item>`  ("history item") elements.
 */
@Component({
  tag: 'aha-history-list',
  styleUrl: 'aha-history-list.css',
  shadow: true,
})
export class AhaHistoryList {
  @Element() host!: HTMLAhaHistoryListElement;

  /** Set to `true` to force the first child `<aha-history-list-item>` to have a line at the top, even if it is the first child `<aha-history-list-item>`. */
  @Prop({ reflect: true, attribute: 'leading-line' }) leadingLine: boolean = false;

  /** Set to `true` to force the last child `<aha-history-list-item>` to have a line at the bottom, even if it is the last child `<aha-history-list-item>`. */
  @Prop({ reflect: true, attribute: 'trailing-line' }) trailingLine: boolean = false;

  render() {
    return (
      <Host role="list">
        <slot></slot>
      </Host>
    );
  }
}
